import types from "./types";

const initialState = {
    list: [],
    activeAlert: null,
    viewerOpen: false,
    filters: {},
    pagination: {
        actualPage: 1,
        previous: null,
        next: null,
        pages: 0,
        count: 0
    },
    error: null,
    saveError: null,
    updatingIds: {},
    loading: false,
    saving: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_NOTIFICATIONS: {
            return {
                ...state,
                loading: true
            };
        }
        case types.GET_NOTIFICATIONS_SUCCESS: {
            const list = action.payload.reduce((entities, notification) => {
                return {
                    ...entities,
                    [notification.id]: {
                        ...notification
                    }
                };
            }, {});
            return {
                ...state,
                list,
                loading: false
            };
        }

        case types.GET_NOTIFICATIONS_FAIL: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        case types.TOGGLE_NOTIFICATION_ACTIVE: {
            const { notification_id } = action.payload;
            return {
                ...state,
                updatingIds: {
                    ...state.updatingIds,
                    [notification_id]: true
                }
            };
        }

        case types.TOGGLE_NOTIFICATION_ACTIVE_SUCCESS: {
            const id = action.payload.id;
            const nextUpdatingIds = { ...state.updatingIds };
            delete nextUpdatingIds[id];

            return {
                ...state,
                list: {
                    ...state.list,
                    [id]: {
                        ...state.list[id],
                        ...action.payload
                    }
                },
                updatingIds: nextUpdatingIds
            };
        }

        case types.TOGGLE_NOTIFICATION_ACTIVE_FAIL: {
            const { notification_id, error } = action.payload;
            const nextUpdatingIds = { ...state.updatingIds };
            delete nextUpdatingIds[notification_id];

            return {
                ...state,
                updatingIds: nextUpdatingIds,
                error
            };
        }

        case types.CHANGE_PAGE: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.page
                }
            };
        }

        case types.UPDATE_PAGINATION: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.actual,
                    pages: action.payload.pages,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    count: action.payload.count
                }
            };
        }

        case types.FILTER_LIST: {
            return {
                ...state,
                filters: action.payload
            };
        }

        case types.FETCH_ACTIVE_ALERT_SUCCESS: {
            return {
                ...state,
                activeAlert: action.payload
            };
        }

        case types.OPEN_ALERT_VIEWER: {
            return { ...state, viewerOpen: true };
        }

        case types.CLOSE_ALERT_VIEWER: {
            return { ...state, viewerOpen: false };
        }

        case types.SAVE_NOTIFICATION: {
            return { ...state, saving: true, saveError: null };
        }

        case types.SAVE_NOTIFICATION_SUCCESS: {
            return { ...state, saving: false, saveError: null };
        }

        case types.SAVE_NOTIFICATION_FAIL: {
            return { ...state, saving: false, saveError: action.payload };
        }

        case types.CLEAR_SAVE_ERROR: {
            return { ...state, saveError: null };
        }

        default: {
            return state;
        }
    }
};
